 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTITLEPAGE from '@/components/xhtml/Titlepage'
 import XHTMLFRONT_MATTER from '@/components/xhtml/Front_Matter'
 import XHTMLDEDICATION from '@/components/xhtml/Dedication'
 import XHTMLCONTENTS from '@/components/xhtml/Contents'
 import XHTMLMAPS from '@/components/xhtml/maps'
 import XHTMLPREFACE from '@/components/xhtml/Preface'
 import XHTMLABBREVIATION from '@/components/xhtml/Abbreviation'
 import XHTMLINTRODUCTION from '@/components/xhtml/Introduction'
 import XHTMLCHAPTER_1 from '@/components/xhtml/Chapter_1'
 import XHTMLCHAPTER_2 from '@/components/xhtml/Chapter_2'
 import XHTMLCHAPTER_3 from '@/components/xhtml/Chapter_3'
 import XHTMLCHAPTER_4 from '@/components/xhtml/Chapter_4'
 import XHTMLCHAPTER_5 from '@/components/xhtml/Chapter_5'
 import XHTMLCONCLUSION from '@/components/xhtml/Conclusion'
 import XHTMLGLOSSARY from '@/components/xhtml/Glossary'
 import XHTMLNOTES from '@/components/xhtml/Notes'
 import XHTMLBIBLIOGRAPHY from '@/components/xhtml/Bibliography'
 import XHTMLINDEX from '@/components/xhtml/Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/Contents",
 			"name" : "xhtml/Contents",
 			"component" : XHTMLCONTENTS
 		},
 		{
 			"path" : "/xhtml/maps",
 			"name" : "xhtml/maps",
 			"component" : XHTMLMAPS
 		},
 		{
 			"path" : "/xhtml/Preface",
 			"name" : "xhtml/Preface",
 			"component" : XHTMLPREFACE
 		},
 		{
 			"path" : "/xhtml/Abbreviation",
 			"name" : "xhtml/Abbreviation",
 			"component" : XHTMLABBREVIATION
 		},
 		{
 			"path" : "/xhtml/Introduction",
 			"name" : "xhtml/Introduction",
 			"component" : XHTMLINTRODUCTION
 		},
 		{
 			"path" : "/xhtml/Chapter_1",
 			"name" : "xhtml/Chapter_1",
 			"component" : XHTMLCHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js